export const FETCH_DISTRIBUTORS_SUCCESS = 'fetch_distributors_success'
export const ADD_DISTRIBUTOR_SUCCESS = 'add_distributor_success'
export const FETCH_DISTRIBUTOR_DETAILS_SUCCESS = 'fetch_distributor_details_success'
export const UPDATE_DISTRIBUTOR_SUCCESS = 'update_distributor_success'
export const FETCH_DISTRIBUTOR_METRICS_SUCCESS = 'fetch_distributor-metrics_success'
